var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C12.5449 2 10.8899 2.0117 10.1924 2.0117C8.6902 2.0117 8.64625 1.97655 8.4014 1.78075C8.0894 1.53125 7.82695 1.3159 7.60185 1.13135C6.59765 0.3081 6.2219 0 5.4739 0H2C0.8972 0 0 0.89695 0 2V11C0 12.103 0.8972 13 2 13H14C15.1028 13 16 12.103 16 11V4C16 2.897 15.1028 2 14 2ZM15 11C15 11.5512 14.5515 12 14 12H2C1.4485 12 1 11.5512 1 11V2C1 1.44875 1.4485 1 2 1H5.4739C5.84035 1 6.00295 1.11375 6.9678 1.9048C7.1956 2.0913 7.46095 2.3091 7.7769 2.56205C8.2818 2.96585 8.53005 3.01175 10.1925 3.01175C10.8184 3.01175 12.6043 3.00005 14.0001 3.00005C14.5516 3.00005 15.0001 3.4488 15.0001 4.00005L15 11Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C12.5449 2 10.8899 2.0117 10.1924 2.0117C8.6902 2.0117 8.64625 1.97655 8.4014 1.78075C8.0894 1.53125 7.82695 1.3159 7.60185 1.13135C6.59765 0.3081 6.2219 0 5.4739 0H2C0.8972 0 0 0.89695 0 2V11C0 12.103 0.8972 13 2 13H14C15.1028 13 16 12.103 16 11V4C16 2.897 15.1028 2 14 2ZM15 11C15 11.5512 14.5515 12 14 12H2C1.4485 12 1 11.5512 1 11V2C1 1.44875 1.4485 1 2 1H5.4739C5.84035 1 6.00295 1.11375 6.9678 1.9048C7.1956 2.0913 7.46095 2.3091 7.7769 2.56205C8.2818 2.96585 8.53005 3.01175 10.1925 3.01175C10.8184 3.01175 12.6043 3.00005 14.0001 3.00005C14.5516 3.00005 15.0001 3.4488 15.0001 4.00005L15 11Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFolder);
export default __webpack_public_path__ + "static/media/ProjectFolder.a5aa33d367fd9ffc91f07906ac1c24fe.svg";
export { ForwardRef as ReactComponent };